import { createSelector } from 'reselect'
import getIsCurrentRegionUserLoyaltyRegion from './getIsCurrentRegionUserLoyaltyRegion'
import getLoyaltyPaymentMethodEarnConfig, { isLoyaltyPaymentMethodEarnLiveInRegion } from './getLoyaltyPaymentMethodEarnConfig'

/**
 * Payment-method earn is gated by Lab config and a market allowlist (AU at launch), where each market
 * can have its own start time. Logged-out users and non-members get today's experience because the
 * loyalty region check fails for them. In Agent Hub that check always passes, so agents booking for a
 * member get it whenever the config and region allow.
 */
const getIsLoyaltyPaymentMethodEarnEnabled = createSelector(
  (state: App.State) => getLoyaltyPaymentMethodEarnConfig(state),
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => state.geo.currentRegionCode,
  (config, isCurrentRegionUserLoyaltyRegion, regionCode): boolean =>
    isCurrentRegionUserLoyaltyRegion && isLoyaltyPaymentMethodEarnLiveInRegion(config, regionCode),
)

export default getIsLoyaltyPaymentMethodEarnEnabled
